import React, { useState, useEffect, useRef } from 'react';

function Navbar({ onAgregarPaciente, onEliminarPaciente, pacienteActivoId, mensajeExito, onLogout, onVerInicio, onVerCalendario, onGestionUsuario, onAdminUsuarios, onToggleSidebar, pendientesGoogleCount = 0, onAbrirBandejaGoogle }) {
  const [menuAbierto, setMenuAbierto] = useState(false);
  const menuRef = useRef(null);

  const user = JSON.parse(localStorage.getItem('user') || '{}');
  const esAdmin = user.is_staff || user.is_superuser;

  const toggleMenu = () => setMenuAbierto((prev) => !prev);
  const cerrarMenu = () => setMenuAbierto(false);

  useEffect(() => {
    const manejarClickAfuera = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target)) {
        cerrarMenu();
      }
    };
    document.addEventListener('mousedown', manejarClickAfuera);
    return () => document.removeEventListener('mousedown', manejarClickAfuera);
  }, []);

  return (
    <header className="navbar">
      <div className="navbar-brand">
        {onToggleSidebar && (
          <button className="btn-hamburger" onClick={onToggleSidebar} aria-label="Menú de pacientes">
            <span /><span /><span />
          </button>
        )}
        <img src="/LogoSoftCraft.png" alt="Logo" className="navbar-logo" />
        <span className="navbar-titulo">SoftCraftSolutionsSde</span>
      </div>

      <div className="navbar-actions">

        {mensajeExito && (
          <span className="navbar-mensaje-exito">{mensajeExito}</span>
        )}

        <button className="btn-nav btn-campana" onClick={onAbrirBandejaGoogle} title="Eventos de Google Calendar pendientes de revisar">
          <span className="navbar-campana-wrapper">
            🔔
            {pendientesGoogleCount > 0 && (
              <span className="navbar-bell-badge">{pendientesGoogleCount > 99 ? '99+' : pendientesGoogleCount}</span>
            )}
          </span>
        </button>

        <button className="btn-nav btn-inicio" onClick={onVerInicio} title="Ver panel de inicio">
          🏠 Inicio
        </button>

        <button className="btn-nav btn-calendario" onClick={onVerCalendario} title="Ver calendario">
          📅 Calendario
        </button>

        <button className="btn-nav btn-agregar" onClick={onAgregarPaciente} title="Agregar nuevo paciente">
          + Nuevo Paciente
        </button>

        <button
          className="btn-nav btn-eliminar"
          onClick={onEliminarPaciente}
          disabled={pacienteActivoId === null}
          title={pacienteActivoId === null ? 'Selecciona un paciente primero' : 'Eliminar paciente seleccionado'}
        >
          Eliminar Paciente
        </button>

        <div className="config-menu-wrapper" ref={menuRef}>
          <button className="btn-nav btn-config" onClick={toggleMenu} title="Configuración">
            <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" fill="currentColor" viewBox="0 0 16 16">
              <path d="M8 4.754a3.246 3.246 0 1 0 0 6.492 3.246 3.246 0 0 0 0-6.492zM5.754 8a2.246 2.246 0 1 1 4.492 0 2.246 2.246 0 0 1-4.492 0z"/>
              <path d="M9.796 1.343c-.527-1.79-3.065-1.79-3.592 0l-.094.319a.873.873 0 0 1-1.255.52l-.292-.16c-1.64-.892-3.433.902-2.54 2.541l.159.292a.873.873 0 0 1-.52 1.255l-.319.094c-1.79.527-1.79 3.065 0 3.592l.319.094a.873.873 0 0 1 .52 1.255l-.16.292c-.892 1.64.901 3.434 2.541 2.54l.292-.159a.873.873 0 0 1 1.255.52l.094.319c.527 1.79 3.065 1.79 3.592 0l.094-.319a.873.873 0 0 1 1.255-.52l.292.16c1.64.893 3.434-.902 2.54-2.541l-.159-.292a.873.873 0 0 1 .52-1.255l.319-.094c1.79-.527 1.79-3.065 0-3.592l-.319-.094a.873.873 0 0 1-.52-1.255l.16-.292c.893-1.64-.902-3.433-2.541-2.54l-.292.159a.873.873 0 0 1-1.255-.52l-.094-.319zm-2.633.283c.246-.835 1.428-.835 1.674 0l.094.319a1.873 1.873 0 0 0 2.693 1.115l.291-.16c.764-.415 1.6.42 1.184 1.185l-.159.292a1.873 1.873 0 0 0 1.116 2.692l.318.094c.835.246.835 1.428 0 1.674l-.319.094a1.873 1.873 0 0 0-1.115 2.693l.16.291c.415.764-.42 1.6-1.185 1.184l-.291-.159a1.873 1.873 0 0 0-2.693 1.116l-.094.318c-.246.835-1.428.835-1.674 0l-.094-.319a1.873 1.873 0 0 0-2.692-1.115l-.292.16c-.764.415-1.6-.42-1.184-1.185l.159-.291A1.873 1.873 0 0 0 1.945 8.93l-.319-.094c-.835-.246-.835-1.428 0-1.674l.319-.094A1.873 1.873 0 0 0 3.06 4.47l-.16-.292c-.415-.764.42-1.6 1.185-1.184l.292.159a1.873 1.873 0 0 0 2.692-1.115l.094-.319z"/>
            </svg>
          </button>

          {menuAbierto && (
            <div className="config-dropdown">
              <button className="config-opcion" onClick={() => { cerrarMenu(); onGestionUsuario(); }}>
                👤 Gestión de usuario
              </button>
              {esAdmin && (
                <button className="config-opcion" onClick={() => { cerrarMenu(); onAdminUsuarios(); }}>
                  🛠️ Administrar usuarios
                </button>
              )}
              <div className="config-separador" />
              <button className="config-opcion config-opcion-logout" onClick={() => { cerrarMenu(); onLogout(); }}>
                Cerrar sesión
              </button>
            </div>
          )}
        </div>

      </div>
    </header>
  );
}

export default Navbar;